declare global {
  interface Window {
    _mtm?: any[]
  }
}

/**
 * Initialize Matomo Tag Manager by injecting the container script.
 * @param containerUrl Full CDN URL of the MTM container script
 *   e.g. 'https://cdn.matomo.cloud/pamperedchefeu.matomo.cloud/container_vrfl64gz.js'
 */
export function initMatomoTagManager(containerUrl: string): void {
  window._mtm = window._mtm || []
  window._mtm.push({ 'mtm.startTime': new Date().getTime(), 'event': 'mtm.Start' })

  const d = document
  const g = d.createElement('script')
  const s = d.getElementsByTagName('script')[0]

  g.async = true
  g.src = containerUrl
  if (s && s.parentNode) {
    s.parentNode.insertBefore(g, s)
  }
}

/**
 * Push arbitrary data into the MTM data layer.
 * Used for both base data layer pushes and named events.
 */
export function pushMtmData(data: Record<string, any>): void {
  window._mtm = window._mtm || []
  window._mtm.push(data)
}
